import { put } from 'redux-saga/effects';
import api from './../api';
import {
  partnerFetchSuccess,
  partnerFetchFail,
  partnerSaveSuccess,
  partnerSaveFail,
  toastrAdd,
  fetchPartnerUsersSuccess,
  fetchPartnerUsersFail
} from '../actions';

export function* partnerFetchSaga(action) {
  try {
    const response = yield api.partner.getPartner(action.partnerID);

    if (!response.data.data.partner) {
      throw new Error('error in response');
    }
    yield put(partnerFetchSuccess(response.data.data.partner));
  } catch (error) {
    console.log(error);
    yield put(partnerFetchFail(error));
  }
}

export function* partnerSaveSaga(action) {
  try {
    // Save request
    const response = yield api.partner.savePartner(action.partnerID, action.data);
    // Update state
    yield put(partnerSaveSuccess(response.data.data.partner));
   yield put(toastrAdd({details: action.translate('settings.organization_save_success_details'), title: action.translate('settings.organization_save_success_title'), type: 'success'}));
  } catch (response) {
    // Parse response errors
    let { errors, firstError } = yield response;
    // Set toastr notification
    yield put(toastrAdd({...firstError, type: 'error'}));
    // Update state
    let payload = yield {errors, firstError};
    yield put(partnerSaveFail(payload));
  }
}

export function* fetchPartnerUsers({ partnerID }) {
  try {
    const response = yield api.partner.getPartnerUsers(partnerID);
    yield put(fetchPartnerUsersSuccess(response.data.data.users))
  } catch (error) {
    console.log(error);
    yield put (fetchPartnerUsersFail(error.message))
  }
}
